<template>
  <div class="Modal">
    <div class="titulo">
      <p class="titulo__p">
        Welcome to the Online Consulting Management System
      </p>
    </div>
    <font-awesome-icon
      class="icon-title general-title"
      icon="times"
      @click="close"
    />
    <div class="contenido">
      <p class="contenido__p">
        In this interface, the calendar allows you to view the appointments you
        have had and those scheduled with the expert consultant, as well as
        cancel one if necessary
      </p>
      <p class="contenido__p">
        In the tool, you can see the Phase and Process associated with the
        interaction, the consultant name and
        <span class="resaltado"
          >the link generated to hold the meeting online on the scheduled date
          and time</span
        >
      </p>
      <p class="contenido__p">
        Notifications and reminders at the right time will make missing a
        meeting a thing of the past
      </p>
      <p class="contenido__p">
        Additionally, an integration link with the miro.com tool will allow you
        to share interactive dashboards, templates, diagrams and notes in real
        time with the consultant, scaling collaboration with confidence,
        <span class="resaltado">
          achieving an agile and effective interaction</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
<style scoped>
.Modal {
  background: white;
  box-shadow: 0px 0px 15px 1px #707070;
  height: 100%;
  border-radius: 10px;
  padding: 20px;
  position: relative;
}
.titulo__p {
  text-align: center;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 30px;
  margin: 30px;
}
.contenido__p {
  font-family: PT Sans, sans-serif;
  font-weight: 500;
  margin: 10px;
  font-size: 20px;
}
.resaltado {
  color: #f68b23;
}
.general-title {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 25px;
  color: #f68b23;
}
@media (max-width: 600px) {
  .titulo__p {
    font-size: 20px;
  }
  .contenido__p {
    font-size: 15px;
  }
}
</style>